import { LinearProgress } from "@mui/material";
import type { FC } from "react";
import { NotSet } from "../components/not-set";
import { useBuiltHtmlMessage } from "../hooks/use-built-html-message";
import { useEmailPreviewSource } from "../hooks/use-email-preview-source";
import { usePreviewContext } from "../preview-context";
import { EmailDesktopPreivew } from "./email-desktop-preview";
import { EmailMobilePreview } from "./email-mobile-preview";

export const PreviewBodyNewsletterContent: FC = () => {
  const {
    moment_preview_data: { email_moment, dynamic_segment_id_map },
    preview_info,
    preview_test_data,
    previewMode,
  } = usePreviewContext();

  const {
    design,
    subject,
    additional_merge_fields: email_additional_merge_fields,
    use_unlayer_email_preview,
  } = useEmailPreviewSource();

  const { loading, data } = useBuiltHtmlMessage({
    body: email_moment?.body ?? undefined,
    dynamic_segment_id_map,
    preview_info,
    preview_test_data,
    design,
    subject,
    email_additional_merge_fields,
    use_unlayer_email_preview,
  });

  if (loading) return <LinearProgress />;
  if (!data) return <NotSet />;

  return previewMode === "desktop" ? (
    <EmailDesktopPreivew data={data} />
  ) : (
    <EmailMobilePreview data={data} />
  );
};
